import {THEME} from '@wandb/weave/common/css/color.styles';
import {Link} from '@wandb/weave/common/util/links';
// @todo: Migrate to 'Icon' from @wandb/components.
import {Icon} from '@wandb/weave/components/Icon';
import styled from 'styled-components';

export const PostCardContainer = styled.div<{$borderColor?: string}>`
  display: flex;
  flex-direction: column;
  background: ${THEME.bgSurface};
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  height: 100%;
  border: 1px solid ${p => p.$borderColor || 'transparent'};
  padding: 16px;
  transition: box-shadow 0.2s ease;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);

  &:hover {
    box-shadow: 0px 4px 12px 0px rgba(13, 15, 18, 0.15);
    transform: translateY(-2px);
  }
`;

export const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Tags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const TagBadge = styled.span<{
  $backgroundColor: string;
  $textColor: string;
}>`
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 6px;
  font-family: 'Source Sans 3', sans-serif;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
  text-transform: uppercase;
  white-space: nowrap;
  background-color: ${p => p.$backgroundColor};
  color: ${p => p.$textColor};
`;

export const Title = styled.h3`
  font-family: 'Source Sans 3', sans-serif;
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  color: ${THEME.textPrimary};
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const Description = styled.p`
  font-family: 'Source Sans 3', sans-serif;
  font-size: 16px;
  line-height: 24px;
  color: light-dark(#555e6d, var(--moon-350));
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const Meta = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: auto;
  font-family: 'Source Sans 3', sans-serif;
  font-size: 14px;
  color: light-dark(#555e6d, var(--moon-350));
  font-weight: 400;
  padding-top: 16px;
`;

export const ClockIcon = styled(Icon)`
  font-size: 16px;
  color: light-dark(#555e6d, var(--moon-350));
`;

export const CardLink = styled(Link)`
  text-decoration: none;
  color: inherit;
  display: block;
  height: 100%;

  &:hover {
    text-decoration: none;
    color: inherit;
  }
`;
